export default "__VITE_ASSET__BV1PPYpr__"